import * as d3 from 'd3'

const STARTDATE = '2020-03-05'

export function onlyUnique(value: string, index: number, self: string[]) {
  return self.indexOf(value) === index
}
 const padDate = (datestring: string) => {
  const parts = datestring.split('-')
  return (
    parts[0] +
    '-' +
    (+parts[1] < 10 ? '0' + +parts[1] : +parts[1]) +
    '-' +
    (+parts[2] < 10 ? '0' + +parts[2] : +parts[2])
  )
}
export const formatData = (inputdata: {
  floors: {
    healthy: number
    infected: number
    death: number
    date: string
  }[]
  date: string
  deathDate: string
  staff: number
  death: number
}) => {
  let formatedData: statusType[][] = []
  inputdata.floors.forEach((etage, i) => {
    let h: statusType[] = []
    Object.entries(etage).forEach(f => {
      if (f[0] !== 'death' && f[0] !== 'date' && f[0] !== 'floor') {
        h = h.concat(
          [...new Array(f[1] > 0 ? f[1] : 0)].map(m => f[0] as statusType)
        )
      }
    })
    h.sort((a, b) => b.localeCompare(a))
    while (h.length < 16) h.push('gone')

    formatedData.push(h)
  })
  let staffdata = [...Array(inputdata.staff)].map(m => 'staff')
  while (staffdata.length < 20) staffdata.push('gone')
  let deathdata = [...Array(inputdata.death)].map(m => 'death')
  while (deathdata.length < 20) deathdata.push('gone')

  return {
    floors: formatedData,
    date: inputdata.date,
    staff: [staffdata],
    death: [deathdata],
    deathDate: inputdata.deathDate
  }
}
export const getDataForDate = (
  data: {
    date: string
    death: number
    floor: number
    healthy: number
    infected: number
    staff: number
  }[],
  date: string
) => {
  const datesOfLastDeathChange = ['', '', '', '', '']
  const dataForDate = data.filter(f => f.date === date)
  const death = dataForDate.reduce((a, b) => a + b.death, 0)
  const staff = dataForDate.reduce((a, b) => a + b.staff, 0)

  d3.groups(data, d => {}).forEach((floor, i) =>
    floor[1].forEach((day, j) => {
      if (j === 0 || new Date(day.date) > new Date(date)) return
      if (day.death > floor[1][j - 1].death)
        datesOfLastDeathChange[i] = day.date
    })
  )

  datesOfLastDeathChange.map(m => {
    return +new Date(m) || +new Date(STARTDATE) + 1000 * 60 * 60 * 24
  })

  const deathDate = new Date(
    Math.max(
      ...datesOfLastDeathChange.map(
        m =>
          +new Date(m )||
          +new Date(STARTDATE) + 1000 * 60 * 60 * 24
      )
    )
  )
    .toISOString()
    .split('T')[0]

  return formatData({
    floors: dataForDate.slice(1),
    date,
    staff: staff,
    death,
    deathDate
  })
}
export const formatDate = (
  datestring: string,
  lang?: 'de' | 'fr' | undefined
) => {
  const d = new Date(padDate(datestring))
  const langIso = lang === 'fr' ? 'fr-CH' : 'de-CH'
  const formatOptions = { day: 'numeric', month: 'long' }
  return d.toLocaleDateString(langIso, formatOptions)
}
export const colors: { [key: string]: string } = {
  healthy: '#E9E9E9',
  infected: '#FFE462',
  staff: '#FFE462',
  death: '#d3343f',
  gone: '#fff',
  label: '#9698a8'
}
